var moreInfo = "https://shopfront-cdn.tekoapis.com/static/98504a319c079288.svg";

export { moreInfo as default };
